module.exports = __webpack_public_path__ + "static/media/columbia_team.daf3b8c5.jpg";